import React, {Component, Fragment} from 'react';
import { Redirect } from "react-router-dom";

class ChangePassword extends Component {
    componentDidMount() {
        // window.location.href=KEYCLOAK_LOGIN_DIRECT_URL
    }

    render(){
        return(
            <Fragment>

            </Fragment>
        );
    }

}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/ChangePassword.js